import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';

interface Banner {
  id: string;
  message: string;
  bgColor: string;
  textColor: string;
  linkUrl?: string;
  linkText?: string;
}

export default function RepFirmBanner() {
  const { user } = useAuth();
  const [banners, setBanners] = useState<Banner[]>([]);
  const [dismissed, setDismissed] = useState<Set<string>>(new Set());

  const repFirmId = (user as any)?.repFirmId;

  useEffect(() => {
    if (!repFirmId) return;
    const token = localStorage.getItem('auth_token');
    fetch(`${import.meta.env.VITE_API_URL || '/api'}/rep-portal/public/banners/${repFirmId}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setBanners(data);
      })
      .catch(() => {});
  }, [repFirmId]);

  if (!repFirmId || banners.length === 0) return null;

  const visible = banners.filter(b => !dismissed.has(b.id));
  if (visible.length === 0) return null;

  return (
    <>
      {visible.map(banner => (
        <div
          key={banner.id}
          className="px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-3"
          style={{ backgroundColor: banner.bgColor, color: banner.textColor }}
        >
          <span>{banner.message}</span>
          {banner.linkUrl && (
            <a
              href={banner.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline opacity-90 hover:opacity-100"
              style={{ color: banner.textColor }}
            >
              {banner.linkText || 'Learn more'}
            </a>
          )}
          <button
            onClick={() => setDismissed(prev => new Set(prev).add(banner.id))}
            className="ml-2 opacity-60 hover:opacity-100"
            style={{ color: banner.textColor }}
          >
            x
          </button>
        </div>
      ))}
    </>
  );
}
